import React from 'react';

import { styled } from '../styled';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import { theme } from '../theme';

const CustomFormControl = styled(FormControl)({
  color: '#4DAC27'
});

const CustomTextField = styled(TextField)(({ textfieldvariant, componentvariant }) => ({
  ...textfieldvariant,
  textAlign: 'center',
  padding: 2,
  fontSize: 16,
  minWidth: 250,
  maxWidth: 370,
  height: 35,
  borderRadius: 20,
  color: '#4DAC27',
  border: '1px solid #4DAC27',
  backgroundColor: '#FFF',
  textAlign: componentvariant !== 'displayText' ? 'center' : 'left',
  paddingLeft: 15,
  paddingRight: 15
}));

const CustomFormLabel = styled(FormLabel)({
  marginBottom: 5,
  paddingBottom: 0,
  color: '#4DAC27',
  fontSize: 14
});

const formControlLabelPlacementTop = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
};

const formLabelLabelPlacementTop = {
  marginBottom: 0,
  paddingRight: 8
};

const formLabelLabelPlacementBottom = {
  marginBottom: 0,
  paddingRight: 8
};

const variants = {
  grey: {
    backgroundColor: '#f9f5fa',
    color: '#FFFFFF'
  },
  white: {
    backgroundColor: 'white',
    color: '#FFFFFF',
    textAlign: 'center',
    verticalAlign: 'center'
  },
  column: {
    marginTop: 8
  },
  fullWidth: {
    width: '100%'
  }
};

export const SpTextInput = ({
  style,
  variant,
  type,
  step,
  min,
  errorLabel,
  autocomplete,
  label,
  labelColor,
  componentvariant,
  displayLabel = true,
  displayErrorLabel = false,
  textAlign,
  formControlStyle,
  textfieldVariant = 'white',
  labelPlacementLeft,
  InputProps,
  inputPropsStyle,
  minValue,
  maxValue,
  ...rest
}) => {
  const controlStyle = {
    ...style,
    ...formControlStyle,
    ...variants[variant],
    ...(labelPlacementLeft && formControlLabelPlacementTop)
  };

  const labelStyle = labelPlacementLeft ? formLabelLabelPlacementTop : {};
  const errorLabelStyle = labelPlacementLeft ? formLabelLabelPlacementBottom : {};

  return (
    <CustomFormControl style={controlStyle}>
      {displayLabel ? <CustomFormLabel style={(labelStyle, { color: labelColor ? labelColor : '#4DAC27' })}>{label}</CustomFormLabel> : <></>}
      <CustomTextField
        {...rest}
        textfieldvariant={variants[textfieldVariant]}
        componentvariant={componentvariant}
        variant="standard"
        type={type}
        inputProps={{
          style: {
            color: theme.colors.mainGreen.main,
            textAlign: textAlign ? textAlign : 'left',
            ...inputPropsStyle
          },
          min: min,
          max: maxValue,
          step: step,
          lang: 'en-US'
        }}
        autoComplete={'email'}
      />
      {displayErrorLabel ? <CustomFormLabel style={errorLabelStyle}>{errorLabel}</CustomFormLabel> : <></>}
    </CustomFormControl>
  );
};

export default SpTextInput;
